import { Alert, Divider, Heading, Stack, Text } from 'braid-design-system';
import { SmartTextLink } from 'scoobie';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import type { Breadcrumb } from '#src/components/Breadcrumbs/Breadcrumbs.tsx';
import { PageNavigationButtonLinks } from '#src/components/PageNavigationButtonLinks/PageNavigationButtonLinks.tsx';
import { WrapperRenderer } from '#src/components/mdx/WrapperRenderer.tsx';
import type { PageNavigation } from '#src/docs.tsx';
import { releaseNotes } from '#src/release-notes.map.ts';

const Content = () => (
  <Stack space="xlarge">
    {Object.entries(releaseNotes)
      .sort(([a], [b]) => b.localeCompare(a))
      .map(([date, documents]) => (
        <Stack space="large" key={date}>
          <Heading level="3">{date}</Heading>
          <Divider />
          <Stack space="large">
            {documents.map((document, index) => (
              <WrapperRenderer document={document} key={`${date}-${index}`}>
                {({ children }) => <Stack space="large">{children}</Stack>}
              </WrapperRenderer>
            ))}
          </Stack>
        </Stack>
      ))}
  </Stack>
);

const ReleaseNotes = ({
  next,
  prev,
  breadcrumbs,
}: {
  next?: PageNavigation;
  prev?: PageNavigation;
  breadcrumbs: Breadcrumb[] | null;
}) => (
  <BasePage title="Release notes" breadcrumbs={breadcrumbs}>
    <Alert tone="promote">
      <Stack space="medium">
        <Text>
          Noteworthy additions and changes to the SEEK API are documented here.
        </Text>

        <Text>
          Subscribe to our{' '}
          <SmartTextLink href="https://developer.seek.com/feed/public.atom">
            Atom
          </SmartTextLink>{' '}
          or{' '}
          <SmartTextLink href="https://developer.seek.com/feed/public.rss">
            RSS
          </SmartTextLink>{' '}
          feed to be notified of updates.
        </Text>
      </Stack>
    </Alert>

    <Content />

    <PageNavigationButtonLinks next={next} prev={prev} />
  </BasePage>
);

export default ReleaseNotes;
